// extracted by mini-css-extract-plugin
module.exports = {"timeline":"styles_timeline__WDR_4","container":"styles_container__ms3v9","column":"styles_column__cNPvO"};